import { NgModule } from '@angular/core';
import { EqualValidatorDirective } from '../directives/equal-valiadator.directive';
import { AutoFocusDirective } from '../directives/auto-focus.directive';
import { PaginatorComponent } from '../directives/paginator/paginator.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NumberOnlyDirective } from '../directives/number-only.directive';
import {poValidationDirective} from '../directives/poValidation.directive';

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [
    PaginatorComponent,
    NumberOnlyDirective,
    EqualValidatorDirective,
    AutoFocusDirective,
    poValidationDirective
  ],
  exports: [
    PaginatorComponent,
    NumberOnlyDirective,
    poValidationDirective,
    EqualValidatorDirective,
    AutoFocusDirective
  ]
})
export class DirectiveModule {}
